import sidebarButtonStyles from "@/components/common/sidebar-buttons/styles/sidebar-buttons.module.scss";
import Link from "next/link";
import UnfilledButton from "@/components/common/unfilled-button";
import { useGlobalModalContext } from "@/providers/modal-provider/modal-provider";

const SubscribeButton = () => {
  const { hideModal } = useGlobalModalContext();
  return (
    <Link
      className={sidebarButtonStyles.button_wrapper}
      href={"/pricing"}
      onClick={hideModal}
    >
      <UnfilledButton
        text={"Subscribe"}
        textColor={"#F9A825"}
        borderColor={"#F9A825"}
      />
    </Link>
  );
};

export default SubscribeButton;
